export const API_ENDPOINT = 'https://api.venturedesign.se'
export const CDN_URL = 'https://cdn.venturedesign.se'
